// src/components/ProtocolSteelHardness.js
// Протокол измерения твердости стали основных элементов (1,3,4 вкладка готовы)
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CButton,
  CFormTextarea,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormSelect,
  CSpinner
} from "@coreui/react";
import PhotoTab from './Tabs/PhotoTab';
// 1. Импорт модального окна
import AddSteelHardnessMeasurements from './Tabs/AddSteelHardnessMeasurements';

const ProtocolSteelHardness = ({ ldoc, nvalue, activeProtocolId, refreshProtocols }) => {
  const [activeKey, setActiveKey] = useState(1);
  const [groupedData, setGroupedData] = useState({});
  const [normativeDocs, setNormativeDocs] = useState([]);
  const [measurementToolsOptions, setMeasurementToolsOptions] = useState([]);
  const [measurementConductedByOptions, setMeasurementConductedByOptions] = useState([]);
  const [developedByOptions, setDevelopedByOptions] = useState([]);
  const [normativeDocsList, setNormativeDocsList] = useState([]);
  const [measurementToolsList, setMeasurementToolsList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [dateMeasurement, setDateMeasurement] = useState("");
  const [dateProtocol, setDateProtocol] = useState("");
  const [newProtocolId, setNewProtocolId] = useState(null);
  const [photoTabProtocolId, setPhotoTabProtocolId] = useState(null);
  const [selectedNormativeDoc, setSelectedNormativeDoc] = useState('');
  const [selectedMeasurementTool, setSelectedMeasurementTool] = useState('');
  const [selectedConductedBy, setSelectedConductedBy] = useState('');
  const [selectedDevelopedBy, setSelectedDevelopedBy] = useState('');
  const [conclusionText, setConclusionText] = useState("");
  const [noteText, setNoteText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // 2. Состояние для модального окна
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const token = localStorage.getItem("token");

  const getIdByName = (name, list) => {
    if (!name || !list || !Array.isArray(list)) return null;
    const item = list.find((item) => item.name === name);
    return item ? item.Id : null;
  };

  // 3. Функция открытия модального окна
  const openAddModal = () => {
    setIsAddModalVisible(true);
  };

  // 4. Функция обработки данных из модального окна
  const handleSaveNewMeasurement = (newMeasurementData) => {
    console.log("Новое измерение для добавления:", newMeasurementData);
    // TODO: Здесь будет логика добавления данных в таблицу (состояние)
    // и, возможно, вызов API для сохранения на сервере.
    setIsAddModalVisible(false); // Закрываем модальное окно после сохранения
  };

  function formatDateToISO(originalDate) {
    if (!originalDate) return "";
    const parts = originalDate.split('.');
    if (parts.length !== 3) return "";
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  useEffect(() => {
    setPhotoTabProtocolId(activeProtocolId || newProtocolId || null);
  }, [activeProtocolId, newProtocolId]);

  useEffect(() => {
    if (ldoc && nvalue !== null) {
      setIsLoading(true);
      axios
        .get(`/api/ldoc/${ldoc}/protocol-info/${nvalue}/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const result = response.data.data || [];
          const grouped = {};
          const normativeList = [];
          const measurementToolsListTemp = [];
          const peopleListTemp = [];
          const developedByList = [];
          const normativeDocsListTemp = [];
          const measurementToolsListWithId = [];
          const peopleListWithId = [];
          result.forEach((item) => {
            const key = item[""]?.trim();
            const value = item.ObjName;
            if (!key) return;
            switch (key) {
              case "Нормативные документы":
                if (value) {
                  normativeList.push(value);
                  normativeDocsListTemp.push({ Id: item.Id, name: value });
                }
                break;
              case "Средства измерений":
                if (value) {
                  measurementToolsListTemp.push(value);
                  measurementToolsListWithId.push({ Id: item.Id, name: value });
                }
                break;
              case "Измерения проводил":
                if (value) {
                  peopleListTemp.push({ Id: item.Id, name: value });
                }
                break;
              case "Разработал":
                if (value) {
                  developedByList.push(value);
                }
                break;
              default:
                if (key !== "Выводить значения") {
                  grouped[key] = value;
                }
            }
          });
          setNormativeDocsList(normativeDocsListTemp);
          setMeasurementToolsList(measurementToolsListWithId);
          setPeopleList(peopleListWithId);
          setGroupedData(grouped);
          setNormativeDocs(normativeList);
          setMeasurementToolsOptions(measurementToolsListTemp);
          setMeasurementConductedByOptions(peopleListTemp.map(p => p.name));
          setDevelopedByOptions(developedByList);
          setSelectedNormativeDoc(normativeList[0] || "");
          setSelectedMeasurementTool(measurementToolsListTemp[0] || "");
          setSelectedConductedBy(peopleListTemp.length > 0 ? peopleListTemp[0].name : "");
          setSelectedDevelopedBy(developedByList[0] || "");
          setDateMeasurement(grouped["Дата проведения измерений"] || "");
          setDateProtocol(grouped["Дата протокола"] || "");
          if (activeProtocolId) {
            axios.get(`/api/protocol-details/${activeProtocolId}/`, {
              headers: { Authorization: `Bearer ${token}` },
            })
              .then(response => {
                const data = response.data.data;
                if (data && data.length >= 18) {
                  setSelectedNormativeDoc(data[4]?.Value || normativeList[0] || "");
                  setSelectedMeasurementTool(data[5]?.Value || measurementToolsListTemp[0] || "");
                  setSelectedConductedBy(data[9]?.Value || (peopleListTemp.length > 0 ? peopleListTemp[0].name : ""));
                  setSelectedDevelopedBy(data[16]?.Value || developedByList[0] || "");
                  setDateMeasurement(formatDateToISO(data[10]?.Value) || "");
                  setDateProtocol(formatDateToISO(data[3]?.Value) || "");
                  const fullConclusionData = data[17]?.Value || "";
                  const noteMarker = "\nПримечание: ";
                  const noteIndex = fullConclusionData.indexOf(noteMarker);
                  if (noteIndex !== -1) {
                    setConclusionText(fullConclusionData.substring(0, noteIndex).trim());
                    setNoteText(fullConclusionData.substring(noteIndex + noteMarker.length).trim());
                  } else {
                    setConclusionText(fullConclusionData.trim());
                    setNoteText(data[12]?.Value?.trim() || "");
                  }
                }
              })
              .catch(error => {
                console.error(`Ошибка загрузки деталей протокола ${activeProtocolId}:`, error);
              })
              .finally(() => {
              });
          } else {
            setConclusionText("");
            setNoteText("");
            setNewProtocolId(null);
          }
        })
        .catch((error) => {
          console.error("Ошибка загрузки данных протокола:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [ldoc, nvalue, token, activeProtocolId]);

  const saveData = () => {
    const effectiveProtocolId = newProtocolId || activeProtocolId || 0;
    const formattedDateProtocol = dateProtocol ? new Date(dateProtocol).toISOString() : null;
    const formattedDateMeasurement = dateMeasurement ? new Date(dateMeasurement).toISOString() : null;
    const payload = {
      Id: effectiveProtocolId,
      Name: "Протокол измерений твердости стали основных элементов",
      ProtocolDate: formattedDateProtocol,
      idMeasuring: getIdByName(selectedMeasurementTool, measurementToolsList),
      idSpecObserver: getIdByName(selectedConductedBy, peopleList),
      idDoc: getIdByName(selectedNormativeDoc, normativeDocsList),
      idPhoto: null, // Пока не используется
      ProtocolNum: groupedData["№ протокола"] || "",
      BaseWidth: 0, // Не используется в этом протоколе
      BeltDiameter: 0, // Не используется в этом протоколе
      SchemaNum: 0, // Не используется в этом протоколе
      DateMeasuring: formattedDateMeasurement,
      idSpecExec: getIdByName(selectedDevelopedBy, peopleList),
      AxisRotate: 0, // Не используется в этом протоколе
      LocationDist: "", // Не используется в этом протоколе
      LocationPoints: "", // Не используется в этом протоколе
      DiscrepBetween: "", // Не используется в этом протоколе
      AvgError: "", // Не используется в этом протоколе
      NType: 1, // Тип 3 для этого протокола (nvalue=1, см. backend)
      Conclusion: conclusionText, // Отправляем только Вывод
      Note: noteText, // Отправляем Примечание отдельно
      RelRollerBelt: 0, // Не используется в этом протоколе
      IsAvgValueDevice: false, // Не используется в этом протоколе
      idProject: 456, // Значение по умолчанию, возможно, нужно динамически или убрать если берется из LDoc
      idNormDocuments: getIdByName(selectedNormativeDoc, normativeDocsList)?.toString() || "",
      idMeasurings: getIdByName(selectedMeasurementTool, measurementToolsList)?.toString() || "",
      Gost: selectedNormativeDoc || "", // Имя норм. документа
      IsOutputHide: false,
      // Note: "", // Не используется, если отправляем отдельно
      TotalPages: 1,
      IsAllowPlanHeights: false, // Не используется в этом протоколе
      IsWorkNotTech: false,
      LDoc: ldoc // Передаем LDoc для определения idObject на бэке
    };
    console.log('Отправляемый payload Steel Hardness Protocol:', payload);
    setIsLoading(true);
    axios.post('/api/protocol/save/', payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        console.log("Ответ от сервера при сохранении Steel Hardness Protocol:", response.data);
        if (!newProtocolId && response.data.protocol_id) {
          const createdProtocolId = response.data.protocol_id;
          console.log("Создан новый протокол Steel Hardness с ID:", createdProtocolId);
          setNewProtocolId(createdProtocolId); // Сохраняем ID нового протокола
          if (!photoTabProtocolId) { // Если photoTabProtocolId еще не установлен
            setPhotoTabProtocolId(createdProtocolId);
          }
        } else {
          console.log("Обновлен протокол Steel Hardness с ID:", effectiveProtocolId);
        }
        console.log(response.data.message || "Протокол успешно сохранен/обновлен");
        if (refreshProtocols) {
          refreshProtocols();
        }
        // Показываем сообщение об успехе
        alert(response.data.message || "Протокол успешно сохранен/обновлен");
      })
      .catch((error) => {
        console.error("Ошибка сохранения/обновления протокола Steel Hardness:", error);
        alert("Ошибка при сохранении/обновлении протокола: " + (error.response?.data?.message || error.message));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <CCard className="mb-4">
      {isLoading && (
        <div className="text-center p-3">
          <CSpinner size="sm" />
          <span className="ms-2">Загрузка/Сохранение данных...</span>
        </div>
      )}
      <CCardBody>
        <CNav variant="tabs" role="tablist">
          <CNavItem>
            <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>Сведения</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>Результаты измерений</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 3} onClick={() => setActiveKey(3)}>Вывод</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 4} onClick={() => setActiveKey(4)}>Фото измерений</CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          {/* Вкладка "Сведения" */}
          <CTabPane visible={activeKey === 1}>
            <CTable borderless>
              <CTableBody>
                {[
                  "Объект",
                  "Адрес объекта",
                  "Основание для проведения измерений",
                  "Цель измерений"
                ].map((key, idx) => (
                  <CTableRow key={idx}>
                    <CTableDataCell className="fw-bold" style={{ width: "30%" }}>{key}</CTableDataCell>
                    <CTableDataCell>
                      <input
                        type="text"
                        className="form-control"
                        value={groupedData[key] || ""}
                        readOnly
                      />
                    </CTableDataCell>
                  </CTableRow>
                ))}
                {/* Поле "Нормативные документы" */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Нормативные документы
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedNormativeDoc}
                      onChange={(e) => setSelectedNormativeDoc(e.target.value)}
                      disabled={normativeDocs.length === 0}
                    >
                      {normativeDocs.length > 0 ? (
                        normativeDocs.map((doc, idx) => (
                          <option key={idx} value={doc}>
                            {doc}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                {/* Средства измерений */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Средства измерений
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedMeasurementTool}
                      onChange={(e) => setSelectedMeasurementTool(e.target.value)}
                      disabled={measurementToolsOptions.length === 0}
                    >
                      {measurementToolsOptions.length > 0 ? (
                        measurementToolsOptions.map((tool, idx) => (
                          <option key={idx} value={tool}>
                            {tool}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                {/* Измерения проводил */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Измерения проводил
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedConductedBy}
                      onChange={(e) => setSelectedConductedBy(e.target.value)}
                      disabled={measurementConductedByOptions.length === 0}
                    >
                      {measurementConductedByOptions.length > 0 ? (
                        measurementConductedByOptions.map((person, idx) => (
                          <option key={idx} value={person}>
                            {person}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                {/* Дата проведения измерений */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Дата проведения измерений
                  </CTableDataCell>
                  <CTableDataCell>
                    <input
                      type="date"
                      className="form-control"
                      value={dateMeasurement}
                      onChange={(e) => setDateMeasurement(e.target.value)}
                    />
                  </CTableDataCell>
                </CTableRow>
                {/* Остальные поля из groupedData */}
                {Object.entries(groupedData).map(([key, value], idx) => {
                  const skipKeys = [
                    "Объект",
                    "Адрес объекта",
                    "Основание для проведения измерений",
                    "Цель измерений",
                    "№ протокола",
                    "Дата проведения измерений",
                    "Дата протокола"
                  ];
                  if (skipKeys.includes(key)) {
                    return null;
                  }
                  return (
                    <CTableRow key={`other-${idx}`}>
                      <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                        {key}
                      </CTableDataCell>
                      <CTableDataCell>
                        <input
                          type="text"
                          className="form-control"
                          value={value || ""}
                          readOnly
                        />
                      </CTableDataCell>
                    </CTableRow>
                  );
                })}
                {/* Дата протокола */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Дата протокола
                  </CTableDataCell>
                  <CTableDataCell>
                    <input
                      type="date"
                      className="form-control"
                      value={dateProtocol}
                      onChange={(e) => setDateProtocol(e.target.value)}
                    />
                  </CTableDataCell>
                </CTableRow>
                {/* Разработал */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Разработал
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedDevelopedBy}
                      onChange={(e) => setSelectedDevelopedBy(e.target.value)}
                      disabled={developedByOptions.length === 0}
                    >
                      {developedByOptions.length > 0 ? (
                        developedByOptions.map((person, idx) => (
                          <option key={idx} value={person}>
                            {person}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </CTabPane>
          {/* Вкладка "Результаты измерений" */}
          <CTabPane visible={activeKey === 2}>
            <div className="mb-3 d-flex gap-2">
              {/* 5. Кнопка "Добавить" открывает модальное окно */}
              <CButton color="secondary" onClick={openAddModal}>Добавить</CButton>
              <CButton color="secondary">Изменить</CButton>
              <CButton color="secondary">Удалить</CButton>
            </div>
            <CTable bordered>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>Отметка</CTableHeaderCell>
                  <CTableHeaderCell>Элемент</CTableHeaderCell>
                  <CTableHeaderCell>НВ</CTableHeaderCell>
                  <CTableHeaderCell>ов, МПА</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {/* Таблица с результатами измерений */}
                <CTableRow>
                  <CTableDataCell colSpan="4" className="text-center">
                    Данные результатов измерений будут отображаться здесь.
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
            {/* 6. Компонент модального окна */}
            <AddSteelHardnessMeasurements
              visible={isAddModalVisible}
              onClose={() => setIsAddModalVisible(false)}
              onSave={handleSaveNewMeasurement}
            />
          </CTabPane>
          {/* Вкладка "Вывод" */}
          <CTabPane visible={activeKey === 3}>
            <div className="mb-3">
              <label className="form-label fw-bold">Примечание</label>
              <CFormTextarea
                rows={4}
                placeholder="Введите примечание..."
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
              />
            </div>
            <div>
              <label className="form-label fw-bold">Вывод</label>
              <CFormTextarea
                rows={6}
                placeholder="Введите вывод по результатам измерений..."
                value={conclusionText}
                onChange={(e) => setConclusionText(e.target.value)}
              />
            </div>
          </CTabPane>
          {/* Вкладка "Фото измерений" */}
          <CTabPane visible={activeKey === 4}>
            {photoTabProtocolId ? (
              <PhotoTab idProtocol={photoTabProtocolId} />
            ) : (
              <div className="text-center text-muted">
                Для добавления фото необходимо сначала сохранить протокол.
              </div>
            )}
          </CTabPane>
        </CTabContent>
        <div className="d-flex justify-content-end gap-3 mt-4 pt-2">
          <CButton color="secondary" onClick={() => {/* Логика отмены, например, закрытие модалки */ }}>
            Отменить
          </CButton>
          <CButton color="success" onClick={saveData} disabled={isLoading}>
            {isLoading ? 'Сохранение...' : 'Сохранить'}
          </CButton>
        </div>
      </CCardBody>
    </CCard>
  );
};

export default ProtocolSteelHardness;